import { Typography } from 'antd';
import { Route } from '../../RouteManagement/routingApi';

const { Text } = Typography;

type Props = {
  route: Route;
};

const RouteDragOverlay = ({ route }: Props) => {
  return (
    <div
      style={{
        padding: '12px',
        backgroundColor: 'white',
        borderRadius: '8px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
        border: '1px solid #d9d9d9',
        width: '280px',
        cursor: 'grabbing',
      }}
    >
      <div>
        <Text strong>{route.name}</Text>
      </div>
      <div>
        <Text type="secondary" style={{ fontSize: '12px' }}>
          {route.jobsCount || 0} jobs
        </Text>
      </div>
    </div>
  );
};

export default RouteDragOverlay;
